<template>
    <b-modal
      size="md"
      :hideFooter="true"
      :hideHeader="true"
      id="confirmFinishTest"
      centered
    >
      <template slot="default">
        <b-row>
          <b-col class="float-left">
            <em class="fas fa-lg fa-exclamation"></em>
          </b-col>
        </b-row>
        <b-container class="confirm-modal-cnt mt-2">
          <b-row class="text-center">
            <h6 class="confirm-modal-text text-center mb-4">
              Вы действительно хотите завершить тест?
            </h6>
          </b-row>
          <b-row>
            <b-col sm="12" md="6">
              <b-button @click="finishTest" class="confirm-modal-btn" variant="primary">
                Завершить
              </b-button>
            </b-col>
            <b-col sm="12" md="6">
              <b-button @click="closeModal" class="confirm-modal-btn" variant="outline-primary">
                Отмена
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'

import TestAPI from '@/api/test'


export default {
  name: 'FinishTestConfirm',
  computed: {
    ...mapGetters({
      test: 'test/getTest'
    })
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('confirmFinishTest')
    },
    finishTest() {
      const questions = this.$cookies.keys().filter((k) => k.includes(`test_${this.test.id}`))
      const answers = []
      questions.forEach((q) => {
        const id = this.test.subSections.filter((ss) => ss.id === Number(q.split('_')[2])).length > 0
          ? this.test.subSections.filter((ss) => ss.id === Number(q.split('_')[2]))[0].task.id
          : null
        if (id) {
          answers.push({
            id,
            answer: (q.split('_')[3] === 'flash' || q.split('_')[3] === 'formula')
              ? this.$cookies.get(q)
              : JSON.parse(this.$cookies.get(q))
          })
        }
      })
      TestAPI.sendTestAnswers(this.$route.params.courseBookId,
        this.$route.params.sectionId, answers)
        .then((response) => {
          if (response.status === 200) {
            const cAnswers = this.$cookies.keys().filter((k) => k.includes(`test_${this.test.id}`))
            cAnswers.forEach((a) => {
              this.$cookies.remove(a)
            })
            this.fetchMarksForCourse({ courseId: this.$route.params.courseBookId })
            this.$router.push(`/education/${this.$route.params.courseBookId}/test/${this.$route.params.sectionId}`)
          }
        })
    },
    ...mapActions({
      fetchMarksForCourse: 'education/fetchMarksForCourse'
    })
  }
}
</script>

<style scoped lang="scss">

  .confirm-modal-btn {
    width: 100%;
  }

  .confirm-modal-text {
    margin: 0 auto;
    width: 100%;
  }

  .resetName {
    width: 100%;
    margin-bottom: 20px;
  }

</style>
